import React from 'react';
var lang = window.localStorage.getItem('lang') || 'en-US';
var LocalizationContext = React.createContext({
  language: lang,
  isEnglish: lang.split('-')[0].toLocaleLowerCase() === 'en'
});
export default LocalizationContext;